import { MyTypo } from "../../utils/typography/typographier";
function CardKey({ dataElement }) {
  return (
    <div className="cardElement">
      <div className="cardElement-container1">
        <div className="cardElement-container1-titles">
          <h1 className="cardElement-container1-titles-title">{dataElement.title}</h1>
        </div>
        <div className="cardElement-container1-titles">
          <sup className="cardElement-container1-titles-titleNumber">{dataElement.titleNumber}</sup>
        </div>
      </div>
      <div className="cardElement-container1">
        <p className="cardElement-container1-description" id="key-police">
          {MyTypo(dataElement.description)}
        </p>
      </div>
    </div>
  );
}

export default CardKey;
